import React, { useState, useEffect } from "react";
import icons from "./data/icons";

const ScrollTopButton = ({ isMenuOpen }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`
        fixed
        bottom-3
        right-4
        sm:bottom-3
        sm:right-5
        lg:bottom-4
        z-[9999]

        w-8 h-8
        sm:w-9 sm:h-9

        flex items-center justify-center
        rounded-lg

        bg-slate-800/30
        backdrop-blur-2xl
        border border-slate-600/30
        text-cyan-400

        shadow-md
        shadow-cyan-500/20

        hover:bg-slate-800/40
        hover:border-cyan-500/40
        hover:text-cyan-300
        hover:shadow-cyan-500/40
        hover:scale-110

        transition-all
        duration-300
        group

        ${
          isVisible && !isMenuOpen
            ? "opacity-100 translate-y-0 animate-bounce"
            : "opacity-0 translate-y-6 pointer-events-none"
        }
      `}
      aria-label="Back to top"
    >
      <icons.ChevronUp
        className="
          text-xs
          sm:text-sm
          group-hover:-translate-y-0.5
          transition-transform
          duration-300
        "
      />
    </button>
  );
};

export default ScrollTopButton;